<template>
    <label for="label" class="block text-sm mt-5 font-medium text-gray-700">{{ label }} <span v-if="requires == 'True'" class="text-red-500 text-xs" > *</span></label>
    <div class="mt-2 flex rounded-md shadow-sm">

        <input type="text" :placeholder="placeholder" :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)" v-bind="$attrs"
            class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" />
    </div>
</template>

<script>

export default {
    props: {
        label: {
            type: String,
            default: "",

        },
        placeholder: {
            type: String,
            default: "",

        },
        requires: {
            type: String,
            default: 'false'
        },

        modelValue: {
            type: [String, Number],
            default: "",

        }
    }
}

</script>